export const MAP_GEOFENCES_DELETE_GROUP_OPEN_MODAL = "MAP_GEOFENCES_DELETE_GROUP_OPEN_MODAL";
export const MAP_GEOFENCES_DELETE_GEOFENCE_GROUP = "MAP_GEOFENCES_DELETE_GEOFENCE_GROUP";
export const MAP_GEOFENCES_DELETE_GEOFENCE_GROUP_RESPONSE = "MAP_GEOFENCES_DELETE_GEOFENCE_GROUP_RESPONSE";